"use client"

import { Button } from "../ui/3d-button"
import { IconCheck } from "@tabler/icons-react"
import { motion } from "framer-motion"

export function PricingSection() {
  const plans = [
    {
      name: "Starter",
      price: "$79",
      period: "в месяц",
      description: "Идеально для начинающих брендов",
      features: [
        "До 500 сообщений в месяц",
        "1 Instagram аккаунт",
        "Базовые автоматические ответы",
        "Email поддержка",
        "Интеграция с Shopify/WooCommerce",
      ],
    },
    {
      name: "Growth",
      price: "$149",
      period: "в месяц",
      description: "Для растущих брендов с активным потоком клиентов",
      features: [
        "До 2,000 сообщений в месяц",
        "2 Instagram аккаунта",
        "Продвинутое обучение системы вашему стилю",
        "Синхронизация с товарами в реальном времени",
        "Приоритетная поддержка",
        "Детальная аналитика",
      ],
      featured: true,
    },
    {
      name: "Scale",
      price: "$299",
      period: "в месяц",
      description: "Для established брендов и multi-brand владельцев",
      features: [
        "Неограниченное количество сообщений",
        "5 Instagram аккаунтов",
        "Индивидуальная настройка системы",
        "Все интеграции",
        "Персональный менеджер",
        "Доступ для разработчиков",
        "Возможность white-label",
      ],
    },
  ]

  return (
    <section id="pricing" className="py-24 px-6 bg-secondary">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-6">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="font-serif text-4xl md:text-5xl font-bold mb-4"
          >
            Инвестиция, которая окупается за первую неделю
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg text-muted-foreground max-w-2xl mx-auto mb-4"
          >
            Virtual Assistant стоит $400-800/месяц и работает только 8 часов. InstaSell работает 24/7 за fraction цены.
          </motion.p>
          <p className="text-sm text-accent font-semibold">
            30-дневная гарантия возврата денег. Если не сэкономите минимум 10 часов в неделю - вернем 100% оплаты.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-12">
          {plans.map((plan, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`rounded-2xl p-8 border-2 ${
                plan.featured ? "bg-background border-primary shadow-lg scale-105" : "bg-background border-border"
              }`}
            >
              {plan.featured && (
                <div className="text-xs font-bold text-primary uppercase tracking-wider mb-4">Популярный выбор</div>
              )}
              <h3 className="font-serif text-2xl font-bold mb-2">{plan.name}</h3>
              <div className="mb-4">
                <span className="text-4xl font-bold">{plan.price}</span>
                <span className="text-muted-foreground ml-2">{plan.period}</span>
              </div>
              <p className="text-muted-foreground mb-6 leading-relaxed">{plan.description}</p>
              <Button stretch className="mb-6 rounded-full">
                Начать бесплатный период
              </Button>
              <div className="space-y-3">
                {plan.features.map((feature, featureIndex) => (
                  <div key={featureIndex} className="flex items-start gap-3">
                    <IconCheck className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                    <span className="text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
